// 后端地址
export const BASE_URL = process.env.VUE_APP_BACK_URL;



// WEBPACK FOOTER //
// ./src/config/index.js